import { configureStore, Action, combineReducers } from "@reduxjs/toolkit";
import { ThunkAction } from "redux-thunk";
import reducers from "./reducer";
import {loadUserFromLocal} from "../utils/getAuth";
import { persistStore, persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import {useDispatch} from "react-redux";

const persistedState = loadUserFromLocal();
const persistConfig = {
    key: "root",
    storage: storageSession,
    blacklist: ["user"]
};
const rootReducer = combineReducers(reducers);
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
    reducer: persistedReducer,
    preloadedState: {
        user: {
            ...persistedState
        }
    }
});
const persistor = persistStore(store);

export {store, persistor};

// types
export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>();
export type AppThunk = ThunkAction<void, RootState, unknown, Action<string>>
